export const TX_IBC_SEND_AMOUNT_SET = 'TX_IBC_SEND_AMOUNT_SET';
export const TX_IBC_SEND_TOKEN_SET = 'TX_IBC_SEND_TOKEN_SET';
export const TX_IBC_SEND_ADDRESS_SET = 'TX_IBC_SEND_ADDRESS_SET';
export const TX_IBC_SEND_CHAIN_INFO_SET = 'TX_IBC_SEND_CHAIN_INFO_SET';
export const TX_IBC_SEND_CUSTOM_PORT_SET = 'TX_IBC_SEND_CUSTOM_PORT_SET';
export const TX_IBC_SEND_CUSTOM_CHANNEL_SET = 'TX_IBC_SEND_CUSTOM_CHANNEL_SET';
export const TX_IBC_SEND_MEMO_SET = 'TX_IBC_SEND_MEMO_SET';